import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import de from './locales/de.json';
import en from './locales/en.json';

// The MV platform offers German and English only; German is the default.
const LANGUAGE_KEY = 'disiLanguage';
export const DEFAULT_LANGUAGE = 'de';
export const SUPPORTED_LANGUAGES = [
  'de',
  'en',
];

export function isSupportedLanguage(language) {
  return SUPPORTED_LANGUAGES.includes(language);
}

function readStoredLanguage() {
  try {
    return localStorage.getItem(LANGUAGE_KEY);
  } catch {
    return null;
  }
}

export function persistLanguage(language) {
  try {
    localStorage.setItem(LANGUAGE_KEY, language);
  } catch {
    // localStorage unavailable (private browsing, etc.) - non-fatal.
  }
}

function detectInitialLanguage() {
  const stored = readStoredLanguage();

  return isSupportedLanguage(stored) ? stored : DEFAULT_LANGUAGE;
}

i18n.use(initReactI18next).init({
  resources: {
    de: { translation: de },
    en: { translation: en },
  },
  lng: detectInitialLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: {
    // React already escapes interpolated values.
    escapeValue: false,
  },
});

document.documentElement.lang = i18n.language;

i18n.on('languageChanged', (language) => {
  document.documentElement.lang = language;
});

export default i18n;
